"use client";

import React from "react";
import useAuthModal from "@/hooks/useAuthModal";
import AuthModal from "@/components/common/AuthModal";
import { useSession } from "next-auth/react";
import LOGO_DARK from "@/img/general/logo-only.svg";
import Image from "next/image"
const SigninStrip = () => {
  const { isModalOpen, openModal, closeModal } = useAuthModal();
  const { data: session, status } = useSession();

  // Don't render the component if the user is logged in
  if (status === "authenticated") {
    return null;
  }
  return (
    <>
      <AuthModal isOpen={isModalOpen} toggle={closeModal} />
      <section className="layout-pt-md">
        <div className="container">
          <div className="d-flex flex-column flex-md-row align-items-center justify-content-center align-items-md-between justify-content-md-between gap-3" style={{
            backgroundColor: "#032843",
            padding: "20px 20px",
            color: "#fff",
            borderRadius: "30px"
          }}>
             <div className="fw-500"> <Image src={LOGO_DARK} alt="logo icon"  width={50} height={50}  /></div>
          <div className="text-center text-md-start">
            <div className="fw-700 text-20">Unlock member-only hotel prices before you book</div>
            <div className="text-14 mt-5" style={{ opacity: 0.82 }}>
              Sign in or create a free account to see Roave&apos;s best available rates.
            </div>
          </div>
          <div>
            <button
              onClick={openModal}
              type="button"
              className="button px-20 fw-600 text-16 border-white -outline-white h-41 text-white onHover w-200"
            >
              Unlock member rates
            </button>
          </div>
         
          </div>
        </div>
      </section>


    </>
  );
};

export default SigninStrip;
